import React from 'react';
import { render } from 'react-dom';
import { SessionProvider } from '@atlas/session';
import 'core-js/stable';
import 'isomorphic-fetch';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import config from 'configAlias';
import { get } from 'lodash-es';
import { StyleProvider } from '@piggybank/global-toolkit';
import '@piggybank/core/lib/styles.css';
import '@piggybank/form/lib/styles.css';
import { Provider } from 'react-redux';
import 'srcAlias/favicon.ico';
import App from 'srcAlias/client/App';
import createReduxStore from './utils/createReduxStore';
import createMockServer from './mockServer';
import * as serviceWorker from './serviceWorker';
import 'client/utils/tealium';

export let store;

//mock server is created for api mocking for testing purpose.
//Please enable CREATE_MOCK_SERVER flag in env file.
createMockServer();

export async function initialize({ rootSelector = 'root', initialState } = {}) {
  const rootElement = document.getElementById(rootSelector);
  store = createReduxStore(initialState);
  if (rootElement) {
    render(
      <Provider store={store}>
        <SessionProvider
          idleWarning={get(
            config,
            'appConfig.applicationTimeout.applicationWarningTimeout'
          )}
          idleTimeout={get(
            config,
            'appConfig.applicationTimeout.applicationMaximumTimeout'
          )}
        >
          <StyleProvider>
            <App />
          </StyleProvider>
        </SessionProvider>
      </Provider>,
      rootElement
    );
  } else {
    throw new Error(
      `Could not attach to element '${rootSelector}'. It doesn't exist in the DOM.`
    );
  }
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}

if (process.browser) {
  const initialState = window.__INITIAL_STATE__
    ? JSON.parse(window.__INITIAL_STATE__)
    : {};

  initialize({ initialState });
}
